function ProductItem(obj, action, isBOM = false) {
  if (typeof obj !== "object") return {}

  this.action = action
  this.erp_order = obj.erp_order
  this.erp_order_line_num = Number.parseFloat(obj.line_num)
  this.export_description = ""
  this.reserved_8 = ""
  this.reserved_9 = ""
  this.mark_for_address3 = ""
  this.mark_for_attention_to = ""
  this.mark_for_city = ""
  this.mark_for_country = ""
  this.mark_for_email_address = ""
  this.mark_for_fax_num = ""
  this.mark_for_name = ""
  this.mark_for_phone_num = ""
  this.mark_for_postal_code = ""
  this.mark_for_state = ""
  this.country_of_origin = obj.country_of_origin || ""
  this.item = obj.product
  this.net_price = obj.price != null ? parseFloat(obj.price) : 0
  this.quantity = isBOM ? 0 : obj.qty != null ? parseInt(obj.qty, 10) : 0
  this.quantity_um = "EA"
}

export default ProductItem
